import Param from '../param';

let param = new Param();

export default class bgManager {
    constructor() {

        this.$container = $("#l-body-bg");
        this.$line = this.$container.find(".l-bg-line");

    }
    start(){

        if(param.displayType === 'sp'){
            TweenMax.staggerFromTo(this.$line,5, {
                y:-100
            },{
                y:window.innerHeight*1.5,
                repeat:-1,
                repeatDelay:3,
                ease: "Power2.easeOut",
            },0.2);
        }else{
            TweenMax.staggerFromTo(this.$line,5, {
                x:-100
            },{
                x:window.innerWidth*1.5,
                repeat:-1,
                repeatDelay:3,
                ease: "Power2.easeOut",
            },0.2);
        }


    }
    render(){
    }
    resize(){

    }
}